/**
 * Imports component and basic implement from angular core.
 */
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
/**
 * Angular router import.
 */
import { Router } from '@angular/router';
/**
 * Import Service.
 */
import { NewLanguageService } from './../../dataservices/new-language/new-language.service';
import { FunCollectionService } from './../common-functions/fun-collection.service';
import { PostApiService } from './../../dataservices/post-api.service';

/**
 * Directive imports.
 */
import { ButtonDirective } from '../../directives/ga.directive';

/**
 * Model Imports.
 */
import { ConsentData } from './../model/teleconsulting.model';
/**
 * Subscription import from rxjs.
 */
import { Subscription } from 'rxjs';
/**
 * Import Constant File.
 */
import { TARGET_TYPE } from './../../constants/app.constants';

@Component({
  selector: 'app-docquity-tele-consulting',
  templateUrl: './docquity-tele-consulting.component.html',
  styleUrls: ['./docquity-tele-consulting.component.scss']
})
export class DocquityTeleConsultingComponent implements OnInit, OnDestroy {
  /**
   * Get user track id.
   */
  @Input() userTrackId: string;
  /**
   * Consent form action perform key.
   */
  public openConsentForm = false;
  /**
   * Consent form agree screen.
   */
  public consentAgreeForm = false;
  /**
   * Consent form in progress screen.
   */
  public consentProgress = false;
  /**
   * Consent success screen.
   */
  public consentSuccess = false;
  /**
   * Consent failed screen.
   */
  public consentFailed = false;
  /**
   * Get consent Data.
   */
  public allowConsentGet = false;
  /**
   * Consent data object.
   */
  public consentData: ConsentData = null;
  /**
   * Subscription for consent to unsubscribe.
   */
  public consentBannerSubs: Subscription;

  /**
   * Used to store page session time.
   */
  public sessionTime = { 'start_time': '', 'end_time': '' };
  /**
   * Available values for Target object.
   */
  public targetType = TARGET_TYPE;

  /**
   * Hold start time of consent form open.
   */
  public startTime: string;


  /**
   * Instance created.
   */
  constructor(
    public mls: NewLanguageService,
    private postSer: PostApiService,
    public router: Router,
    public fcs: FunCollectionService,
    private directive_ser: ButtonDirective
  ) { }

  /**
   * Initialize the component.
   */
  ngOnInit(): void {
    /**
     * Call consent banner function.
     */
    this.consentBanner();
  }

  /**
   * Used to open consent form modal.
   */
  consentForm(): void {
    const d = new Date();
    this.sessionTime.start_time = d.getTime().toString();
    this.sessionTime.end_time = d.getTime().toString();
    this.directive_ser.productDetailEvent(
      Object.assign({}, this.sessionTime),
      this.mls.googleEventText.dc_consent.key1,
      '0',
      '0',
      this.mls.googleEventText.grandround.category,
      this.userTrackId);

    if (this.consentData.consent === 0 && this.consentData.target === null) {
      this.startTime = d.getTime().toString();
      this.openConsentForm = true;
      this.consentAgreeForm = true;
      this.consentProgress = false;
      this.consentSuccess = false;
      this.consentFailed = false;
      this.allowConsentGet = false;
    } else if (this.consentData.consent === 1 && this.consentData.target === null) {
      this.startTime = d.getTime().toString();
      this.openConsentForm = true;
      this.consentAgreeForm = false;
      this.consentProgress = false;
      this.consentSuccess = false;
      this.consentFailed = true;
      this.allowConsentGet = true;
      this.consentBanner();
    } else if (this.consentData.consent === 1 && this.consentData.target !== null) {
      if (this.consentData.target.type === this.targetType.LINK ||
        this.consentData.target.type === this.targetType.EXTERNAL_LINK) {
        this.fcs.openUrlInNewTab(this.consentData.target.url);
        window.location.reload();
      }
      this.allowConsentGet = false;
    }
  }

  /**
   * Used to close consent form modal.
   */
  closeModal(action: boolean): void {
    this.openConsentForm = action;
  }

  /**
   * Consent banner.
   */
  consentBanner(): void {
    const consent = 0;
    const action = 'get-detail';
    this.consentBannerSubs = this.postSer.consentBanner(consent, action).subscribe(data => {
      if (data && data.status === 1 && data.code === 2000) {
        this.consentData = data.data.consent_data;
        if (this.consentData && this.consentData.consent === 1 && this.consentData.target !== null && this.allowConsentGet) {
          this.consentAgreeForm = false;
          this.consentProgress = false;
          this.consentSuccess = true;
          this.consentFailed = false;
          setTimeout(() => {
            this.consentSuccess = false;
            if (this.consentData.target.type === this.targetType.LINK ||
              this.consentData.target.type === this.targetType.EXTERNAL_LINK) {
              this.fcs.openUrlInNewTab(this.consentData.target.url);
              window.location.reload();
            }
          }, 1000);
        }
      } else if (data && data.status === 0 && data.code === 2000) {
        this.fcs.errorHandeler(data.error.msg);
      } else {
        this.fcs.errorHandeler(data.error.msg);
      }
    }, error => {
      this.fcs.errorHandeler(error);
    });
  }

  /**
   * Used to unsubscribe all subscriptions.
   */
  ngOnDestroy(): void {
    if (this.consentBannerSubs) {
      this.consentBannerSubs.unsubscribe();
    }
  }
}
